module.exports = __webpack_public_path__ + "media/coffee-preferences/cream_and_sugar_none-d7d56f37.png";